import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from 'src/app/all/header/header.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
//Interface

@Component({
    selector: 'app-not-found',
    imports: [
        CommonModule,
        HeaderComponent,
        RouterModule
    ],
    templateUrl: './404.component.html',
    styleUrls: ['./404.component.scss']
})
export class notFoundComponent implements OnInit {
  public projects:any = [];
  public currentRouteLink: string = '';
  
  constructor(private title: Title,
    private route:ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.title.setTitle('Aglo - Oops 404' );
    
    this.currentRouteLink = this.router.url;
    if(this.currentRouteLink == '/architect/profil'){
      this.router.navigate(['/architect/profile/user']);
    }
  }

}
